import { Col, Row, Input, Grid } from "antd";
import "./RequestsList.css";
import RequestItemPreview from "../RequestItem/RequestItemPreview";
import { useMobxStores } from "../../stores/stores";
import { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { SearchOutlined } from "@ant-design/icons";
const { useBreakpoint } = Grid;

const RequestsList = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;
  const { requestsStore } = useMobxStores();
  const timerRef = useRef(null);

  useEffect(() => {
    const fetchRequests = async () => {
      if (requestsStore.searchTerm) {
        await requestsStore.GetRequestsSearchResults();
      } else {
        await requestsStore.GetRequestListings();
      }
    };
    fetchRequests();
  }, [requestsStore, requestsStore.searchTerm]);

  const debouncedSearch = () => {
    return (value) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(
        () => requestsStore.setSearchTerm(value),
        300
      );
    };
  };

  const handleSearch = debouncedSearch();

  return (
    <>
      {" "}
      {isMobile ? (
        <Col className="requests-list-wrapper">
          <Row>
            <Input
              style={{
                // minWidth: "100px",
                // width: "50%",
                height: "36px",
                // marginRight: "12px",
                background: "rgba(215, 215, 215, 0.4)",
                border: "0.2px solid rgba(255, 255, 255, 0.4)",
                backdropFilter: "blur(15px)",
                borderRadius: "9px",
                marginBottom: "12px",
              }}
              defaultValue={requestsStore.searchTerm}
              className="learning-graph-search"
              placeholder="Search by username or title"
              suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Row>
          <Row gutter={[0, 32]}>
            {requestsStore.requestListings?.map((request) => (
              <Col
                justify={"center"}
                align={"middle"}
                key={request.id}
                xl={5}
                xxl={4}
                md={10}
                sm={14}
                xs={24}
              >
                <RequestItemPreview request={request} />
              </Col>
            ))}
          </Row>
        </Col>
      ) : (
        <Col className="requests-list-wrapper">
          <Row>
            <Input
              defaultValue={requestsStore.searchTerm}
              className="learning-graph-search"
              placeholder="Search by username or title"
              suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Row>
          <Row gutter={[0, 32]}>
            {requestsStore.requestListings?.map((request) => (
              <Col
                justify={"center"}
                align={"middle"}
                key={request.id}
                xl={5}
                xxl={4}
                md={10}
                sm={14}
                xs={24}
              >
                <RequestItemPreview request={request} />
              </Col>
            ))}
          </Row>
        </Col>
      )}
    </>
  );
};

export default observer(RequestsList);
